import { render } from "./LkButton.vue?vue&type=template&id=181e9844"
import script from "./LkButton.vue?vue&type=script&lang=js"
export * from "./LkButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__